import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { TariffPrices, UpdateTariffPrices } from '@ste/shared';
import { apiFetch } from './auth.ts';

// Prices for the customer (ADR-0018). Changing them restarts evcc (some seconds).

export const useTariffs = () =>
  useQuery({ queryKey: ['tariffs'], queryFn: () => apiFetch<TariffPrices>('/tariffs') });

export function useUpdateTariffs() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateTariffPrices) =>
      apiFetch<TariffPrices>('/tariffs', { method: 'PUT', body: JSON.stringify(body) }),
    onSuccess: (data) => client.setQueryData(['tariffs'], data),
    onSettled: () => void client.invalidateQueries({ queryKey: ['installer'] }),
  });
}
